var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-nav"},[(_vm.prev)?_c('div',{staticClass:"prev",on:{"click":_vm.handlerPrev}},[_c('img',{staticClass:"ico",attrs:{"src":require("assets/images/icon-prev.png")}})]):_vm._e(),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }